// Polls skip an existing request. An explicit refresh (for example after saving)
// requests one trailing read, so an older in-flight response cannot hide a save.
export function createRefreshQueue(work: () => Promise<void>) {
  let running: Promise<void> | null = null;
  let again = false;
  return {
    get busy() { return running !== null; },
    run() {
      again = true;
      if (!running) {
        running = Promise.resolve().then(async () => {
          try { while (again) { again = false; await work(); } }
          finally { running = null; }
        });
      }
      return running;
    },
  };
}
